import { SlotGameType1_2_2Screen } from "../SlotGameType1_2_2Screen";
import { Scale} from "../../MyHelpers";
import { IReadOnlyResourceManager, LoadingStage, ResourceManager } from "../../ResourceManager/ResourceManager";
// namespace SlotGames2 {
    export class ShiningChalice2_2Screen extends SlotGameType1_2_2Screen {
     
        public override async ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void>{
           await super.ResourcesLoaded(loadingStage, resourceManager);

            if (loadingStage != LoadingStage.Games) return;
            this.title.style.width = Scale.Wpx(1068);
            this.title.style.height = Scale.Wpx(500);
            this.title.style.backgroundSize = "contain";
    }

    }
// }